module.exports = __webpack_public_path__ + "img/selenium.1c6a3bfc.png";